import { NavLink } from "react-router-dom"
import moment from "moment"
import QuoteDocument from "../../../components/client/quotes/components/document"

// Returns the HTML markup for a quote row
export default function QuoteRow({ quote, clientName, agentName }) {
	// Pull the relevant details from the quote
	const { id, client, created, packages } = quote

	// Format the created date
	const createdDate = moment(created?.seconds, "X").format("MMM D[,] YYYY [at] HH:mm")

	return (
		<tr>
			<td>
				<NavLink to={`client/${client}`}>{clientName}</NavLink>
			</td>
			<td>{agentName}</td>
			<td>{createdDate}</td>
			<td className="client-quote-references">
				{packages?.map((quoteObject, index) => (
					<QuoteDocument
						key={index}
						quoteID={id}
						quotePackage={quoteObject}
					/>
				))}
			</td>
		</tr>
	)
}
